require("./site.coffee")

let componentCss = "/resources/css/svelte.css"
import component from "duo-kit/src/shared/component.js";
import CookieBanner from "./components/cookie-banner.svelte"
component({component:CookieBanner,tagname:"cookie-banner",href:componentCss,shadow:false})